module.exports = __webpack_public_path__ + "img/placeholder/article-detail-banner.jpg";